/**
 * Creates a new object with only the dirty values from a form
 */
export const dirtyValues = (dirtyFields, allValues) => {
  // If *any* item in an array was modified, the entire array must be submitted, because there's no
  // way to indicate "placeholders" for unchanged elements. `dirtyFields` is `true` for leaves.
  if (dirtyFields === true || Array.isArray(dirtyFields)) {
    return allValues
  }

  return Object.fromEntries(
    Object.keys(dirtyFields).map((key) => [
      key,
      dirtyValues(dirtyFields[key], allValues[key])
    ])
  )
}

/**
 * Creates a new object with only properties that pass the test
 * implemented by the provided predicate function
 */
export const filterObject = (obj, predicate) =>
  Object.fromEntries(Object.entries(obj).filter(predicate))

/**
 * Creates a new object with only non-empty properties
 */
export const filterEmpty = (values) =>
  filterObject(values, ([key, value]) => key && !isEmpty(value))

/**
 * Checks if a string, object or array is empty, undefined or null
 */
export const isEmpty = (value) => {
  if (value === null) return true
  if (typeof value === 'object') {
    if (isValidDate(value)) return false
    return Object.keys(value).length === 0
  } else if (typeof value === 'undefined') return true
  else return value.toString().length === 0
}

export const isValidDate = (date) => {
  if (Object.prototype.toString.call(date) === '[object Date]') {
    if (isNaN(date.getTime())) return false
    else return true
  } else return false
}

/**
 * Creates a new object that contains all properties from obj1
 * which also exist in obj2.
 */
export const intersection = (obj1, obj2) => {
  const newObj = Object.keys(obj2).reduce(
    (result, key) => ((result[key] = obj1[key]), result),
    {}
  )
  return newObj
}
